var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTailwind = function SvgTailwind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1000 758.994"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E669A2",
    d: "M1000 325.903H636.264v-93.1H1000v93.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3BE26",
    d: "M952.755 325.903H636.264V93.051h316.491v232.852z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE9C34",
    d: "M821.998 325.903H636.264V0h185.734v325.903z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3BC87",
    d: "M858.538 325.903H636.264V36.365h222.274v289.538z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3721C",
    d: "M636.213 36.42v289.453h185.765V36.42H636.213z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1B02",
    d: "M450.016 325.903h186.248v46.555H450.016v-46.555z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E88D14",
    d: "M636.213 93v232.873h222.432V93H636.213z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D85604",
    d: "M636.213 93v232.873h185.765V93H636.213z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C14303",
    d: "M752.413 325.903H636.264V186.142h116.149v139.761z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB4E18",
    d: "M636.213 232.869v93.004h316.649v-93.004H636.213z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1390D",
    d: "M636.213 232.869v93.004h222.432v-93.004H636.213z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#C22303",
    d: "M636.213 232.869v93.004h185.765v-93.004H636.213z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#AD1B02",
    d: "M636.213 232.869v93.004h116.315v-93.004H636.213z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M676.76 501.249c-31.689 5.634-48.59 29.577-48.59 71.126 0 42.254 22.534 70.423 55.633 70.423 16.197 0 30.281-5.634 59.858-20.423v34.508c-35.915 16.9-57.042 21.126-85.21 21.126-31.69 0-54.227-7.746-71.832-26.76-18.31-18.311-28.169-42.254-28.169-69.72 0-59.858 45.07-101.407 110.563-101.407 42.958 0 73.24 20.423 73.24 49.296 0 19.014-14.086 32.395-34.508 32.395-10.563 0-19.015-3.521-30.986-9.86M518.31 581.53c28.873-35.915 39.437-50.704 39.437-68.31s-14.085-33.1-33.803-33.1c-11.268 0-21.83 6.339-26.76 11.973v73.943L450 629.416v-143.66h-45.07l-74.649 123.24v-123.24h-25.353l-68.31 15.494v17.605l37.324 3.52v152.818h47.183l71.831-118.31v118.31h52.817M93.662 651.249h10.563c38.027 0 59.154-23.24 59.154-69.72 0-38.731-16.9-59.858-48.592-59.858-4.225 0-10.563.704-21.126 2.817v126.76h.001zm0 83.098 30.985 7.042v17.605H2.817v-17.605l28.168-7.042V521.67H0v-17.605l73.943-22.535h19.72v25.353c34.506-21.127 46.478-24.648 64.787-24.648 40.846 0 71.831 38.028 71.831 90.846 0 60.563-41.549 102.112-104.93 102.112-7.042 0-19.014-.704-31.689-1.408"
  })));
};
export default SvgTailwind;